import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'dashboard-dialog',
    templateUrl: 'dashboard-dialog.component.html',
    styleUrls: ['dashboard-dialog.component.scss']
})
export class DashboardDialog implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<DashboardDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any // dossier
    ) {}

    ngOnInit() {
    }
    dismissDialog(){
        this.dialogRef.close();
    }
}